import { render, staticRenderFns } from "./AgentCenter.vue?vue&type=template&id=16b5df36&scoped=true"
import script from "./AgentCenter.vue?vue&type=script&lang=js"
export * from "./AgentCenter.vue?vue&type=script&lang=js"
import style0 from "./AgentCenter.vue?vue&type=style&index=0&id=16b5df36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b5df36",
  null
  
)

export default component.exports